import type { OAIError } from '~/types/openapi';

export class HttpError extends Error {
  constructor(
    public readonly status: number,
    public readonly response: OAIError | unknown,
    public readonly url: string,
  ) {
    super(`HTTP Error ${status}: ${url}`);
    this.name = 'HttpError';
  }

  get userMessage(): string | undefined {
    if (HttpError.isOAIError(this.response)) {
      return this.response.userMessage;
    }
    return undefined;
  }

  get errorCode(): string | undefined {
    if (HttpError.isOAIError(this.response)) {
      return this.response.code;
    }
    return undefined;
  }

  private static isOAIError(response: unknown): response is OAIError {
    return (
      typeof response === 'object' &&
      response !== null &&
      ('code' in response || 'message' in response || 'userMessage' in response)
    );
  }
}
